var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyProcurementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.66675L12.75 3.54175L8.5 1.41675V8.50008",
    stroke: "#2280FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66654 8.49292L1.77071 10.7171C1.6617 10.7789 1.57103 10.8685 1.50794 10.9767C1.44486 11.085 1.41162 11.208 1.41162 11.3333C1.41162 11.4586 1.44486 11.5817 1.50794 11.69C1.57103 11.7982 1.6617 11.8878 1.77071 11.9496L7.79154 15.3921C8.0069 15.5164 8.2512 15.5819 8.49988 15.5819C8.74855 15.5819 8.99285 15.5164 9.20821 15.3921L15.229 11.9496C15.3381 11.8878 15.4287 11.7982 15.4918 11.69C15.5549 11.5817 15.5881 11.4586 15.5881 11.3333C15.5881 11.208 15.5549 11.085 15.4918 10.9767C15.4287 10.8685 15.3381 10.7789 15.229 10.7171L11.3332 8.5M4.59696 9.10209L12.4028 13.5646M12.4028 9.10209L4.60404 13.5646",
    stroke: "#2280FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyProcurementIcon);
export default __webpack_public_path__ + "static/media/PropertyProcurementIcon.2a76afccc1229161a8c1585e371cf206.svg";
export { ForwardRef as ReactComponent };